<nb-card class="filter-sheet">
  <nb-card-header>
    {{ 'filters' | translate }}
    <button nbButton ghost (click)="close()" aria-label="Close"><nb-icon icon="close-outline"></nb-icon></button>
  </nb-card-header>
  <nb-card-body>
    <!-- sort -->
    <div class="sheet-section sort">
      <bst-sort-options [colDefs]="sortColDefs" [currentSort]="currentSort" (pick)="applySort($event)"></bst-sort-options>
    </div>
    <!-- candidate picker -->
    <div class="sheet-section candidate">
      <label class="small-label">{{ 'selectuser.label' | translate }}</label>
      <bst-list-adder
        [placeholder]="'selectuser' | translate"
        [listTemplate]="userlisttemplate"
        [autolist]="true"
        [formControl]="list.curUser"
        [single]="true"
        [fullWidth]="true"
        size="small"
        status="basic"
        [filters]="{logo: true}"
        [target]="'member'">
      </bst-list-adder>
      <ng-template #userlisttemplate let-result="result">
        <nb-user color="#eee" [name]="result.name" [picture]="list.userLogo(result)" size="small"></nb-user>
      </ng-template>
    </div>
    <!-- per-column filters -->
    <div class="sheet-section columns">
      @for (col of filterableColumns; track col.name) {
        <button class="filter-row" [class.active]="filtered(col)" (click)="openColumnFilter(col, $event)">
          <span>{{ col.title | translate }}</span>
          <nb-icon icon="funnel-outline"></nb-icon>
        </button>
      }
    </div>
  </nb-card-body>
</nb-card>
